<template>
    <div>
 <span class="gd-name">{{params.data? params.data.firstname:null}}</span>
 <span class="gd-email" >{{params.data?params.data.email:null}}</span>
 <span class="gd-email" >{{params.data?params.data.phonenumber:null}}</span>
 </div>
</template>